module.exports = __webpack_public_path__ + "img/wellness_activated.f4edef8f.png";